@import '../../../../../constants/spacing.module.less';

.dropdown-indicator-icon {
  height: 16px;
  width: 16px;
  padding: @space-0 @space-4;

  color: var(--default--icon--fill-color--3);

  &.is-open {
    color: var(--grey-900);
  }
}
